import { cn } from "@/lib/utils";

/**
 * Skeleton — shimmer animation thay generic pulse (P2.1-S2 / Doc 30).
 *
 * Sử dụng class `.shimmer` từ globals.css cho gradient sweep loop.
 * Reduced motion → fallback animate-pulse (CSS @media handles).
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn("shimmer rounded-md", className)}
      {...props}
    />
  );
}
